var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0C10.746 0 0 10.746 0 24C0 37.254 10.746 48 24 48C37.254 48 48 37.254 48 24C48 10.746 37.254 0 24 0ZM36.132 19.29C36.498 27.37 30.472 36.378 19.804 36.378C16.56 36.378 13.542 35.426 11 33.796C14.048 34.156 17.09 33.308 19.504 31.418C16.992 31.372 14.87 29.71 14.136 27.428C15.038 27.6 15.926 27.55 16.732 27.33C13.97 26.774 12.062 24.286 12.124 21.624C12.9 22.054 13.784 22.312 14.726 22.342C12.168 20.632 11.444 17.254 12.948 14.672C15.78 18.148 20.014 20.434 24.788 20.674C23.95 17.082 26.676 13.62 30.386 13.62C32.036 13.62 33.53 14.318 34.578 15.434C35.886 15.178 37.118 14.698 38.226 14.04C37.796 15.382 36.886 16.506 35.7 17.218C36.862 17.078 37.97 16.77 38.998 16.312C38.23 17.468 37.258 18.48 36.132 19.29Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.7068c83a.svg";
export { ForwardRef as ReactComponent };